module.exports = __webpack_public_path__ + "static/media/face1.20d487fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/face1.png
// module id = 437
// module chunks = 0